module.exports = __webpack_public_path__ + "img/liyuzhe2.5ff56b6b.jpeg";